module.exports = __webpack_public_path__ + "static/media/四足机器人加强版-PNG.f4ee15cb.png";